module.exports = __webpack_public_path__ + "img/activesuite2.e67fd71d.jpg";